import {ListItemProps} from 'component/partial/MetricSection/MetricSection';

import {MetricsSection} from '/constant/TestIDs';
import {BUSINESS_LEADER} from '/enum/competency.enum';
import {
  REPORT_TEAMS_EXECUTIVE_DIRECTOR,
  REPORT_TEAMS_FIBC,
  REPORT_TEAMS_FIBL,
  REPORT_TEAMS_SENIOR_COACH,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {
  TeamsOverviewSectionProps,
  TeamsOverviewSectionPropsReturn,
} from './TeamsOverviewSection.types';

export const useTeamsOverviewSection = ({
  currentUserCompetency = '',
  teamsExecutiveDirector = 0,
  teamsFibc = 0,
  teamsFibl = 0,
  teamsSenior = 0,
  onShowReport = () => {},
  onShowInfoPopover = () => {},
}: TeamsOverviewSectionProps): TeamsOverviewSectionPropsReturn => {
  const {tt, ts} = useTranslation('screen.teams.section.TeamsOverviewSection');

  const listItems: ListItemProps[] = [
    {
      label: tt('seniorCoach', 'Senior Coach Teams'),
      value: teamsSenior,
      recordsName: REPORT_TEAMS_SENIOR_COACH,
      testID: MetricsSection.metricSeniorCoachTeams,
    },
    {
      label: tt('executiveDirector', 'Executive Director Teams'),
      value: teamsExecutiveDirector,
      recordsName: REPORT_TEAMS_EXECUTIVE_DIRECTOR,
      testID: MetricsSection.metricExecutiveDirectorTeams,
    },
  ];

  if (currentUserCompetency === BUSINESS_LEADER) {
    listItems.push({
      label: tt('fibc', 'FIBC Teams'),
      value: teamsFibc,
      recordsName: REPORT_TEAMS_FIBC,
      testID: MetricsSection.metricFIBCTeams,
    });
    listItems.push({
      label: tt('fibl', 'FIBL Teams'),
      value: teamsFibl,
      recordsName: REPORT_TEAMS_FIBL,
      testID: MetricsSection.metricFIBLTeams,
    });
  }

  const onInfoPress = (payload?: any) => {
    const popoverPayload = {
      heading: tt('info.heading', 'Teams Overview'),
      body: tt(
        'info.body',
        'Teams are the fundamental building blocks to help you progress through milestones and achieve ranks. This section will show you how many Senior Coach, Executive Director, FIBC, and FIBL teams are currently qualified for this month.',
      ),
      ...payload,
    };

    onShowInfoPopover?.(popoverPayload);
  };

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({recordsName, loadingData: {total: value}});

  return {
    listItems,
    onInfoPress,
    onItemPress,
    tt,
    ts,
  };
};
